import { CheckIcon, XIcon } from '../Layout/icons';

const ROUTE_POINT_STATE_STYLE_MAP = {
    PENDING: { label: 'PENDENTE', colorToken: 'gray', icon: null },
    SUCCESS: { label: 'SUCESSO', colorToken: 'green', icon: CheckIcon },
    FAILURE: { label: 'FALHA', colorToken: 'red', icon: XIcon },
};

export function getRoutePointStateValue(apiStateOrValue) {
    if (!apiStateOrValue) return '';
    if (typeof apiStateOrValue === 'string') return apiStateOrValue;
    if (typeof apiStateOrValue === 'object' && apiStateOrValue.value != null) {
        return String(apiStateOrValue.value);
    }
    return '';
}

export function getRoutePointStateMeta(apiStateOrValue) {
    const value = getRoutePointStateValue(apiStateOrValue);
    const apiLabel =
        typeof apiStateOrValue === 'object' && apiStateOrValue?.status
            ? String(apiStateOrValue.status)
            : null;
    const meta = ROUTE_POINT_STATE_STYLE_MAP[value];
    if (!meta) {
        return {
            value,
            label: apiLabel || value || '—',
            colorToken: 'gray',
            icon: null,
        };
    }
    return { value, ...meta, label: apiLabel || meta.label };
}
